import { QUESTIONS_ROUTES } from '../../constants/_routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'
//
const get_levels_data_request = () => {
  return {
    type: questionsTypes.get_levels_data.request
  }
}

const get_levels_data_success = (response) => {
  return {
    type: questionsTypes.get_levels_data.success,
    payload: response.data
  }
}

const get_levels_data_failure = (messages) => {
  return {
    type: questionsTypes.get_levels_data.failure,
    payload: messages
  }
}

const get_pool_data = (skill_id, tags=[]) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_levels_data_request())

    // Request
    axios.get(
      QUESTIONS_ROUTES.levels_per_tag_and_skill,
      {
        params: {
          skill_id: skill_id,
          tags: tags
        }
      }
    ).then( response => {
      // success
      dispatch( get_levels_data_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching pool data."]
      }
      window.showSnackbar('error', errors)
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_levels_data_failure(errors))
    })
  }
}

export {
  get_pool_data
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/questions_per_tag_and_skill.js